<div
  [ngClass]="{
    'bg-palette-m3-system-red-95': status === 'error',
    'bg-palette-m3-system-green-95': status === 'success',
    'bg-palette-m3-system-yellow-98': status === 'warn',
    'bg-palette-m3-system-blue-95': status === 'info' && systemBlue,
    'bg-palette-primary-50': status === 'info' && !systemBlue
  }"
  data-cy="banner-container"
>
  <div [ngClass]="{ 'container m-auto': container }" class="flex gap-5 p-2">
    <ng-container [ngSwitch]="status">
      <mat-icon
        *ngSwitchCase="'error'"
        svgIcon="dls-times-circle-solid"
        class="status-icon text-palette-m3-system-red-40 shrink-0"
        aria-hidden="false"
        [attr.aria-label]="translations"
        [class.invisible]="!showIcon"
      ></mat-icon>
      <mat-icon
        *ngSwitchCase="'success'"
        svgIcon="dls-check-circle-solid"
        class="status-icon text-palette-m3-system-green-40 shrink-0"
        aria-hidden="false"
        [attr.aria-label]="translations"
        [class.invisible]="!showIcon"
      ></mat-icon>
      <mat-icon
        *ngSwitchCase="'warn'"
        svgIcon="dls-exclamation-circle-solid"
        class="status-icon text-palette-m3-system-yellow-55 shrink-0"
        aria-hidden="false"
        [attr.aria-label]="translations"
        [class.invisible]="!showIcon"
      ></mat-icon>
      <mat-icon
        *ngSwitchDefault
        svgIcon="dls-info-circle-solid"
        class="status-icon shrink-0"
        [ngClass]="{
          'text-palette-m3-system-blue-40': systemBlue,
          'text-palette-primary-500': !systemBlue
        }"
        aria-hidden="false"
        [attr.aria-label]="translations"
        [class.invisible]="!showIcon"
      ></mat-icon>
    </ng-container>
    <zelis-clamp
      class="flex-grow [overflow-wrap:anywhere]"
      [clamp]="clamp"
      [expanded]="expanded"
      [showMoreText]="showMoreText"
      [showLessText]="showLessText"
    >
      <ng-content></ng-content>
    </zelis-clamp>
    <div class="shrink" *ngIf="dismissible">
      <button
        class="close-button"
        mat-icon-button
        (click)="onClose()"
        aria-label="close"
        data-cy="banner-close-button"
      >
        <mat-icon svgIcon="dls-times-plain-light"></mat-icon>
      </button>
    </div>
  </div>
</div>
